import { Outlet } from "react-router-dom";

export const ComplianceLayout = () => {
  return <Outlet />;
};
